export default "__VITE_ASSET__Db2H3ipx__"